import React, { useContext, Suspense } from 'react';
import { withRouter,useParams,useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, CircularProgress } from '@mui/material';
//import { useMediaQuery } from '@mui/material';

import withMediaQuery from "flexbiz-core/components/withMediaQuery";
import AuthContext from "flexbiz-core/components/auth/Context";

// Import tĩnh (Static Import) những component dùng chung, dung lượng nhẹ
import BottomNavigation from "./BottomNavigation";

// ================= DYNAMIC IMPORTS (CODE SPLITTING) =================
// LƯU Ý QUAN TRỌNG: Phải khai báo React.lazy ở NGOÀI functional component 
// để tránh việc React tạo lại component type mỗi lần re-render làm mất state.
const AppContainer = React.lazy(() => import('flexbiz-core/components/AppContainer'));
//const Container = React.lazy(() => import('./Container'));
const DashboardBDS = React.lazy(() => import('./DashboardBDS'));
//const DashboardDef = React.lazy(() => import('flexbiz-core/components/dashboard/Dashboard'));
const DashboardDef = React.lazy(() => import('flexbiz-core/components/DynamicDashboard'));

const DashboardAgent = React.lazy(() => import('./DashboardDaiLy'));
// ====================================================================

// Màn hình chờ trong lúc trình duyệt tải file JS (Chunk) về
const LoadingFallback = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100dvh', bgcolor: 'background.default' }}>
    <CircularProgress color="primary" />
  </Box>
);

function HomePage(props) {
  const context = useContext(AuthContext);
  //const isMobile = useMediaQuery('(max-width:540px)');

  const { code: rawCode } = useParams();
  const code = (rawCode || "").toUpperCase();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const title = queryParams.get('title');
  
  let Dash, Cont, requireLogin;
  
  // Xác định các Component sẽ được render dựa trên Context
  switch (context.queryParams?.for_agent) {
    case "1":
      Dash = DashboardAgent;
      Cont = AppContainer;
      requireLogin = true;
      break;
    case "8":
      Dash = DashboardBDS;
      Cont = AppContainer;
      requireLogin = false;
      break;
    default: 
      Dash = DashboardDef;
      Cont = AppContainer;
      requireLogin = true;
      break;
  }

  return (
    // Suspense là BẮT BUỘC khi dùng React.lazy. Nó sẽ hiển thị fallback cho đến khi file JS tải xong
    <Suspense fallback={<LoadingFallback />}>
      <Cont 
        {...props} 
        requireLogin={requireLogin}
        contentSx={{ overflowY: 'hidden' }}
      >
        <Dash containerSx={{height:"100%"}} code={code} contentSx={{pb: context.queryParams.for_agent || context.config?.isMobile?9:0}} title={title}/>
        <BottomNavigation code={"DASHBOARD"} {...props} />
      </Cont>
    </Suspense>
  );
}

HomePage.propTypes = {
  history: PropTypes.any,
  location: PropTypes.any
};

export default withRouter(withMediaQuery('(max-width:540px)')(HomePage));